module.exports = __webpack_public_path__ + "static/media/water-loop.064166dc.mov";